import React, { useState } from "react";
import "./ProductsSection.css";
import { Link } from "react-router-dom";

function ProductsSection() {
  const [showProducts, setShowProducts] = useState(false);

  return (
    <section className="products">

      <h2>Our Products</h2>
      <p className="subtitle">Explore our range of paper & board solutions</p>

      <div className="product-grid">

        {/* Paper & Boards */}
        <div className="product-card" onClick={() => setShowProducts(true)}>
          <img src="/paper.png" alt="paper" />
          <h3>Paper & Boards</h3>
          <p>Click to explore our full product range.</p>
          <button>Explore →</button>
        </div>

      </div>

      {/* 👇 Dynamic Product List */}
      {showProducts && (
        <div className="product-list">
          <h3>Paper & Board Categories</h3>

          <ul>
            <li>Woodfree Coated & Uncoated Papers</li>
            <li>Writing Papers</li>
            <li>Packaging Papers & Boards</li>
            <li>Tissue and Hygiene Papers</li>
            <li>Pulpboard</li>
            <li>Specialty Coated Papers</li>
          </ul>
        </div>
      )}

    </section>
  );
}

export default ProductsSection;